// extracted by mini-css-extract-plugin
export var container = "_so-0";
export var inputWidth = "_so-1";